module.exports = __webpack_public_path__ + "fonts/Gilroy-BoldItalic.2b56aed0.ttf";